export const FirebaseConfig = {
	"projectId": "tadashi-express",
	"appId": "1:372093259555:web:3a203dde084541c8ba4696",
	"databaseURL": "https://tadashi-express-default-rtdb.firebaseio.com",
	"storageBucket": "tadashi-express.appspot.com",
	"locationId": "southamerica-east1",
	"apiKey": "AIzaSyDpIHuvIcYTBbe0M6rokNaxNHULkiveDWM",
	"authDomain": "tadashi-express.firebaseapp.com",
	"messagingSenderId": "372093259555",
	"measurementId": "G-5H7Q3221NQ"
};